import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router";

import { LayoutContext } from "../layout/";

import Loader from "../loader";
import { getEndpoint } from "../helper";

export default function OrderDetails(props) {
    const { setPageTitle } = useContext(LayoutContext);

    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const { id } = useParams();

    const formatNumber = n => n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    const ProductBox = ({ picture, productTitle, brandTitle, price, oldPrice, discount, quantity }) => {
        const Img = () => {
            if (picture && picture.length > 0) return <img src={getEndpoint(`/uploads/shop/product-file/${picture}`)} />;

            return <img src={getEndpoint('/pwa/img/no_pic_750x750.jpg')} />;
        }

        return (
            <div className='box d-f bc-w bw-1 bc--n3 br-3 mb-4'>
                <div className='fsh-0 fg-0' style={{ backgroundColor: '#dddddd', width: '28%' }}>
                    <Img />
                </div>
                <div className='px-2' style={{ width: '82%' }}>
                    <div className='p-r t-1'>
                        <div className='lh-2'>{productTitle}</div>
                        <div className='p-r' style={{ fontSize: '.75em', color: '#777777', top: '-.4em' }}>{brandTitle}</div>
                    </div>
                    <div className='d-f ai-c'>
                        <div className='d-f ai-c jc-c _bc-g-d c-w p-1 br-4'>
                            <div className='d-l fs-4'>{discount}%</div>
                        </div>
                        <div className='mr-2 fw-600'>
                            <div className='d-f ai-c mt-1'>
                                <div className='fs-3' style={{ color: '#9c9c9c', textDecorationLine: 'line-through' }}>{formatNumber(oldPrice)}</div>
                                &nbsp;
                                <div style={{ color: '#9c9c9c', fontSize: '.8em' }}>ریال</div>
                            </div>
                            <div className='d-f ai-c p-r _c-b_b' style={{ top: '-.5em' }}>
                                <div className='fs-3' style={{}}>{formatNumber(price)}</div>
                                &nbsp;
                                <div style={{ fontSize: '.8em' }}>ریال</div></div>
                        </div>
                        <div style={{ borderColor: '#acacac', width: '35%' }} className='mr-a fs-3 bw-1 br-3 ta-c'>{quantity}</div>
                    </div>
                </div>
            </div>
        );
    }

    const BottomButton = () => {
        if (data.orderStatus === 1) {
            return (
                <a href={`https://tamin360.ir/gateway?id=${id}`} target='_blank' className='d-f ai-c jc-c c-w fs-3 _bc-b' style={{ height: '5rem' }}>پرداخت</a>
            );
        }

        const getStatusText = (status) => {
            let text = '';

            if (status === 0) text = 'در حال بررسی';
            else if (status === 2) text = 'در حال آماده سازی';
            else if (status === 3) text = 'ارسال شده';
            else if (status === 4) text = 'تحویل شده';
            else if (status === 5) text = 'لغو شده';
            else if (status === 6) text = 'مرجوع شده';

            return text;
        }

        return (
            <div className='d-f ai-c jc-c c-w fs-3' style={{ height: '5rem', backgroundColor: '#ccc' }}>{getStatusText(data.orderStatus)}</div>
        );
    }

    useEffect(() => {
        setPageTitle('جزئیات سفارش');

        const controller = new AbortController();
        const signal = controller.signal;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await fetch(getEndpoint(`/api/android/order/get?id=${id}`), { signal });
                const json = await response.json();
                setData(json.data);

            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();

        return () => controller.abort();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <div className='p-4' style={{ backgroundColor: '#f5f5f5', paddingBottom: '9rem' }}>
                <div className="d-f mb-2">
                    <div className='_c-95'>شماره سفارش:</div>
                    <div className='mr-a'>{data.trackingCode}</div>
                </div>
                <div className="d-f">
                    <div className='_c-95'>تاریخ ثبت سفارش:</div>
                    <div className='mr-a'>{data.createdAt_}</div>
                </div>
                <div className='my-2' style={{ height: '1px', backgroundColor: '#ddd' }} />
                <div className="d-f mb-2">
                    <div className='_c-95'>تحویل گیرنده:</div>
                    <div className='mr-a'>{data.customerFirstName} {data.customerLastName}</div>
                </div>
                <div className="d-f mb-2">
                    <div className='_c-95'>شماره تماس:</div>
                    <div className='mr-a'>{data.customerMobile}</div>
                </div>
                <div className="">
                    <div className='_c-95'>ارسال به:</div>
                    <div className='mr-a'>{data.customerFullAddress}</div>
                </div>
                <div className='my-2' style={{ height: '1px', backgroundColor: '#ddd' }} />

                {data.orderItems.map(x => {
                    return (
                        <ProductBox
                            key={x.orderItemId}
                            picture={x.picture}
                            productTitle={x.productTitle}
                            brandTitle={x.brandTitle}
                            price={x.price}
                            oldPrice={x.oldPrice}
                            discount={x.discount}
                            quantity={x.quantity}
                        />
                    )
                })}

                <div className="d-f mb-2">
                    <div className='_c-95'>مجموع خرید ({data.orderItems?.length} کالا):</div>
                    <div className='mr-a _c-95'>{formatNumber(data.totalPrice)} ریال</div>
                </div>
                <div className="d-f mb-2">
                    <div className='_c-95'>مجموع تخفیف</div>
                    <div className='mr-a _c-95'>{formatNumber(data.totalDiscount)} ریال</div>
                </div>
                <div className="d-f mb-2">
                    <div className='_c-95'>هزینه ارسال</div>
                    <div className='mr-a _c-95'>{data.postalPrice > 0 ? `${formatNumber(data.postalPrice)} ریال` : 'رایگان'}</div>
                </div>
            </div>
            <div className='p-f b-0 l-0 r-0'>
                <div className="d-f ai-c bc-w px-4 fs-3 btw-1" style={{ height: '4rem', borderTopColor: '#ddd' }}>
                    <div className=''>مبلغ قابل پرداخت</div>
                    <div className='mr-a fw-600'>{formatNumber(data.payablePrice)} ریال</div>
                </div>
                <BottomButton />
            </div>
        </>
    );
}